import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Container from '@material-ui/core/Container'
// import './Hurricanes.css';

// Hurricanes___Components
import HurricanesMap from './HurricanesMap';
import ResumenTemporada from "./ResumenTemporada";

import { SwipeableDrawer, useMediaQuery } from '@material-ui/core';

import './Hurricanes.css';


const drawerWidth = 240;
let drawerTop = 205;
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        background: 'transparent',
        borderWidth: 1,
        height: 'auto',
        // left: theme.spacing(0),
        top: drawerTop,
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
    },
    divider: {
        marginBottom: theme.spacing(5),
    },
    listItemStyle: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(0),
    },
}));

export default function Hurricanes(props) {
    const classes = useStyles();
    const [showHurricanesMapComponent, setShowHurricanesMapComponent] = useState(true);
    const [showResumenTemporadaComponent, setShowResumenTemporadaComponent] = useState(false);

    const [openDrawer, setOpenDrawer] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 1);
        return () => {
            // cleanup
        }
    }, [])

    useEffect(() => {
        const header = document.getElementById('header');
        console.log('headerHeight', header.offsetHeight, header.clientHeight);
        return () => {
            // cleanup
        }
    })

    function setVisible(event, text) {
        setOpenDrawer(false);

        // window.scrollTo(0, 1);
        // scroll suavizado cada vez que cambie de vista...
        const anchor = (event.target.ownerDocument || document).querySelector('#root');
        if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        switch (text) {
            case 'Mapa':
                setShowHurricanesMapComponent(true);
                setShowResumenTemporadaComponent(false);
                break;
            case 'Resumen de la Temporada':
                setShowHurricanesMapComponent(false);
                setShowResumenTemporadaComponent(true);
                break;

            default:
                break;
        }
    }

    const hurricanesIndex = [
        'Mapa',
        'Resumen de la Temporada',
    ];

    return (
        <div /* className={classes.root} */>

            {useMediaQuery("(min-width: 1375px)") &&
                <Drawer
                    // className={classes.drawer}
                    variant="permanent"
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    anchor="right"
                // open={true}
                // onOpen={() => setOpenDrawer(true)}
                // onClose={() => setOpenDrawer(false)}
                >
                    {/* <div className={classes.toolbar}>
                        <Typography variant="h5" color="textSecondary" align="center" id="toolbarText" style={{ color: 'transparent' }}>
                            Contenido
                        </Typography>
                    </div> */}
                    <List>
                        {/* {hurricanesIndex.map((text, index) => (
                            <ListItem button key={text} onClick={(event) => setVisible(event, text)} selected={ }>
                                <ListItemText primary={text} />
                            </ListItem>
                        ))} */}
                        <ListItem className={classes.listItemStyle} button key='Mapa' onClick={(event) => setVisible(event, 'Mapa')} selected={showHurricanesMapComponent}>
                            <ListItemText secondary='Mapa' />
                        </ListItem>
                        <ListItem className={classes.listItemStyle} button key='Resumen de la Temporada' onClick={(event) => setVisible(event, 'Resumen de la Temporada')} selected={showResumenTemporadaComponent}>
                            <ListItemText secondary='Resumen de la Temporada' />
                        </ListItem>
                    </List>
                </Drawer>
            }

            <main className={classes.content}>
                <div className={classes.toolbar} />
                <Container maxWidth="lg">
                    {/* <Typography variant="h5" color="textPrimary" align="center">
                        Documentación de la API
                    </Typography>
                    <Typography variant="subtitle1" color="textSecondary" align="center">
                        Meteorología Santiago de Cuba
                    </Typography> */}
                    <div className="heading">
                        <Typography variant="h4" color="initial" className="efecto-espejo" style={{ marginBottom: 10 }}>
                            Ciclones Tropicales
                        </Typography>
                    </div>

                    {useMediaQuery("(min-width: 1375px)") &&
                        <>
                            {showHurricanesMapComponent && <HurricanesMap />}
                            {showResumenTemporadaComponent && <ResumenTemporada />}
                        </>
                    }

                    {useMediaQuery("(max-width: 1374px)") &&
                        <>
                            <HurricanesMap />
                            <Divider className={classes.divider} />
                            <ResumenTemporada />
                        </>
                    }

                </Container>
            </main>
        </div>
    );
}